import { ReportAd, ReportCampaign } from 'api/interfaces'

export const filterCampaignDataByViews = (data?: ReportCampaign[]): ReportCampaign[] => {
  const sortedData = [...(data ?? [])].sort((a, b) => new Date(a.forDate).getTime() - new Date(b.forDate).getTime())

  const firstIndexWithViews = sortedData.findIndex(item => item.views > 0)
  const lastIndexWithViews = sortedData.map(item => item.views > 0).lastIndexOf(true)

  if (firstIndexWithViews === -1 || lastIndexWithViews === -1) {
    return []
  }

  return sortedData.slice(firstIndexWithViews, lastIndexWithViews + 1)
}

export const filterAdDataByViews = (data?: ReportAd[]): ReportAd[] => {
  const sortedData = [...(data ?? [])].sort((a, b) => new Date(a.forDate).getTime() - new Date(b.forDate).getTime())

  const firstIndexWithViews = sortedData.findIndex(item => item.views > 0)
  const lastIndexWithViews = sortedData.map(item => item.views > 0).lastIndexOf(true)

  if (firstIndexWithViews === -1 || lastIndexWithViews === -1) {
    return []
  }

  return sortedData.slice(firstIndexWithViews, lastIndexWithViews + 1)
}
